import React, { useCallback } from 'react'
import { CircularProgress } from '@material-ui/core'
import PropTypes from 'prop-types'
import Icon from '../../../../atoms/Icon'
import { ICON_NAMES } from '../../../../../constants'
import { useDocumentDownload } from '../../../../../api/documentVault'

function DDPWealthJourneyDocumentItem ({ document }) {
  const { mutateAsync: download, isLoading } = useDocumentDownload()
  const handleClick = useCallback(async () => {
    if (!document?.documentId) return
    await download(document)
  }, [document, download])

  if (!document) return null

  return (
    <div
      className='p-2 flex gap-2 items-center'
      onClick={handleClick}
      style={{ cursor: isLoading || !document?.documentId ? 'default' : 'pointer' }}
    >
      {isLoading ? <CircularProgress size={16} /> : <Icon name={ICON_NAMES.file} />}
      {document.fileName || document.name || 'Attachment'}
    </div>
  )
}

DDPWealthJourneyDocumentItem.propTypes = {
  document: PropTypes.object.isRequired
}
export default DDPWealthJourneyDocumentItem
